import { alpha, SxProps, Theme } from '@mui/material';

const styles: SxProps<Theme> = (theme) => ({
  paddingBottom: 0.25,
  textDecoration: 'none',
  borderBottom: `1px solid ${alpha(theme.palette.primary.light, 0.6)}`,
  transition: theme.transitions.hover,

  '&:hover': {
    borderBottomColor: theme.palette.secondary.main,
    transition: theme.transitions.hover,
  },
});

export default styles;
